import {Component, OnInit, Input} from '@angular/core';
import {Reply} from "../../../../domain/reply";
import {animate, style, state, trigger, transition} from "@angular/animations";
import {Router} from "@angular/router";
import {AuthService} from "../../../../../core/security/auth.service";
import {User} from "../../../../../core/domain/user";
import {Post} from "../../../../domain/post";
import { ProfileStoreService } from 'app/profile/service/profile-store.service';
import { ProfileService } from 'app/profile/service/profile.service';

@Component({
    selector: 'reply-list',
    templateUrl: './reply-list.component.html',
    styleUrls: ['./reply-list.component.scss'],
    providers: [ProfileService],
    animations: [
        trigger('showReplies', [
            state("hide", style({ height: "0px", overflow: "hidden"})),
            state("show" , style({ height: "*", overflow: "hidden" })),
            transition('hide => show', [
                style({
                    opacity: 0
                }),
                animate('300ms ease-in-out')
            ]),
            transition('show => hide', [
                style({
                    opacity: 1
                }),
                animate('195ms ease-in-out')
            ])
        ])
    ]
})
export class ReplyListComponent implements OnInit {

    @Input() replies : Reply[] = null;
    @Input("isVisible") state : string = "hide";
    @Input() post : Post = null;

    user: User = null;
    profilePhoto = '';
    constructor(private router: Router,
                private authService: AuthService, private profileStore: ProfileStoreService) { }

    ngOnInit() {
        this.authService.user
            .subscribe(u => this.user = u);
        this.profileStore.getProfile().subscribe(p => {
            this.profilePhoto = p.profilePhoto;
        })
    }

    public editReply( reply : Reply, event) {
        event.preventDefault();
        this.router.navigate( ["home","post",this.post.id,"reply",reply.id] );
    }

}



// WEBPACK FOOTER //
// ./src/app/fiscalia/component/forum/post/reply-list/reply-list.component.ts